<template lang="html">

  <div class="recetario">

    <section class="banner-intro animation full-view-intro -middle column-center" data="recetario">

      <h1 class="title -intro" v-html="$t('banners_experiencia.recetario.titulo')">
      </h1>

      <h2 class="subtitle-intro"><router-link :to="$t('enlaces.vive_aldonza')">{{$t('vistas.vive_aldonza')}}</router-link></h2>

    </section>

    <section class="intro-experiencias animation">

      <router-link :to="$t('enlaces.vive_aldonza')+'#'+$t('banners_experiencia.recetario.id')" class="back">{{$t('volver')}}</router-link>

      <article class="claim container -xs animation">
        <h2 class="title">{{$t('banners_experiencia.recetario.titulo_intro_experiencia')}}.</h2>
      </article>

      <div class="contenedor-recetario">

        <div class="recetario-texts container row-between ais" v-html="$t('banners_experiencia.recetario.cuerpo_recetario')"></div>

        <div class="recetario-btns container row-between ais">
          <div class="boton">
            <a class="btn" v-scroll-to="'#videos-recetas'">
              <span>{{$t('banners_experiencia.recetario.boton_recetario')}}</span>
            </a>
          </div>

          <div class="boton" v-scroll-to="'#videos-tasting'">
            <a class="btn">
              <span>{{$t('banners_experiencia.recetario.boton_tasting')}}</span>
            </a>
          </div>
        </div>

      </div>


    </section>

    <section class="recetario-videos container" id="videos-recetas" v-if="!!videosRecetas & lang == 'es'">

      <h2 class="title -black">{{$t('banners_experiencia.recetario.recetario')}}</h2>

      <div class="videos-list row-start">

        <video-el @sendVideo="sendToShow" v-for="(video, key) in videosRecetas" :key="key" :data="video"></video-el>

      </div>
      
    </section>

        <section class="recetario-videos container" id="videos-recetas" v-if="!!videosRecetasEN & lang != 'es'">

      <h2 class="title -black">{{$t('banners_experiencia.recetario.recetario')}}</h2>

      <div class="videos-list row-start">

        <video-el @sendVideo="sendToShow" v-for="(video, key) in videosRecetasEN" :key="key" :data="video"></video-el>

      </div>
      
    </section>

    <section class="recetario-videos container" id="videos-tasting" v-if="!!videosTasting">

      <h2 class="title -black">{{$t('banners_experiencia.recetario.tasting_spain')}}</h2>

      <div class="videos-list row-start">

        <video-el @sendVideo="sendToShow" v-for="(video, key) in videosTasting" :key="key" :data="video"></video-el>

      </div>
      
    </section>

    <section class="banner-youtube animation">

      <div class="container">

        <h2 class="title -xs">{{$t('banners_experiencia.recetario.youtube.titulo')}}</h2>

        <p>{{$t('banners_experiencia.recetario.youtube.newsletter')}}</p>

        <a href="https://www.youtube.com/channel/UCbgjP5f05GQqAeg8b2O5xMQ" target="_blank" class="btn"><span>{{$t('banners_experiencia.recetario.youtube.boton')}}</span></a>

      </div>

    </section>

    <div class="contenedor-otras-experiencias animation">
      <otras-experiencias></otras-experiencias>
    </div>


    <video-visualizer :show="show_video" :id="video_to_show" @closeVideo="closeVideo"></video-visualizer>

  </div>

</template>

<script lang="js">

  import otrasExperiencias from '@/components/parts/otras-experiencias';

  import {mapGetters, mapActions} from 'vuex'

  import videoEl from '@/components/parts/video-el'

  import videoVisualizer from '@/components/parts/video-visualizer'

  export default  {
    name: 'recetario',
    data(){
      return {
        video_to_show : '',
        show_video : false
      }
    },
    mounted(){
      this.requestVideos();
    },
    components : {
      'otras-experiencias' : otrasExperiencias,
      'video-el' : videoEl,
      'video-visualizer' : videoVisualizer
    },
    methods : {
      ...mapActions(['requestVideos']),
      sendToShow : function(value){
        this.video_to_show = value;
        this.show_video = true;
      },
      closeVideo : function (){
        this.show_video = false;
        this.video_to_show = '';
      }
    },
    computed : {
      ...mapGetters({
        videosRecetas : 'getVideosRecetas',
        videosRecetasEN : 'getVideosRecetasEN',
        videosTasting : 'getVideosTasting',
        lang : 'getLanguage'
      })
    },


  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .full-view-intro[data=recetario]{
    background: url("/static/img/recetario/background-intro-recetario.jpg") center top/cover no-repeat;
  }

  .intro-experiencias{
    padding: 50px 0 100px 0;
  }

  .title.-intro{
    overflow: visible;
    height: auto;
  }

  .title.-xs{
    text-align: center;
  }


  .intro-experiencias .claim.launched {
    opacity: 1;
    transform: translateY(-40%);
    -webkit-box-shadow: 2px -3px 20px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 2px -3px 20px 2px rgba(0, 0, 0, 0.3);
  }

  .recetario-videos{
    padding-top: 100px;
    padding-bottom: 0px;
    position: relative;
    .title{
      margin-bottom: 50px;
    }
  }

  .recetario .title.-ghost{
    position: absolute;
    left: 0;
    top: -44px;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .recetario-videos .title.-xs{
    margin-bottom: 100px;
  }

  .recetario-btns .boton{
    width: calc(50% - 50px);
    text-align: left;
    margin-top: 50px;
  }

  .banner-youtube{
    background: $mud-brown;
    text-align: center;
    padding: 100px 0;
    text-align: center;
    overflow: hidden;
    margin-top: 100px;

    .title{
      max-width: 640px;
      display: inline-block;
      padding-bottom: 20px;
      transform: translateY(200px);
      opacity: 0;
      transition: 1s;

      &::before{
        display:inline-block;
        left: 50%;
        margin-left: -25px;
        bottom: 0;
      }
    }

    p{
      margin-bottom: 30px;
      text-align: center;
      margin-top: 10px;
      transform: translateY(200px);
      opacity: 0;
      transition: 1s;
      transition-delay: .5s;
    }

    .btn{
      transform: translateY(200px);
      opacity: 0;
      transition: 1s;
      transition-delay: 1s;
    }

    &.launched{
     p,.title,.btn{
      transform: translateY(0);
      opacity: 1;
    }
  }

}

@media screen and (max-width: 700px){
  
  .recetario-btns .boton{
    width: 100%;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/recetario.vue